import { Component } from "react";
import { Bluelagoon } from "@bluelagoon";
import ErrorFallback from "./ErrorFallback";

class GlobalErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, componentStack: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        const componentStack = errorInfo?.componentStack;
        this.setState({ componentStack });
        console.error("GlobalErrorBoundary caught an error:", error, errorInfo);

        Bluelagoon.reportError({
            errorMessage: error?.message || String(error),
            componentStack: componentStack || "",
            url: window.location.href,
            userAgent: navigator.userAgent,
        }).catch(() => {});
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, componentStack: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <ErrorFallback
                    error={this.state.error}
                    componentStack={this.state.componentStack}
                    onReset={this.handleReset}
                />
            );
        }
        return this.props.children;
    }
}

export default GlobalErrorBoundary;
